var items = {
  "block.minecraft.air": "ауа",
  "block.minecraft.stone": "тас",
  "block.minecraft.granite": "гранит",
  "block.minecraft.polished_granite": "жылтыр гранит",
  "block.minecraft.diorite": "диорит",
  "block.minecraft.polished_diorite": "жылтыр диорит",
  "block.minecraft.andesite": "андезит",
  "block.minecraft.polished_andesite": "жылтыр андезит",
  "block.minecraft.grass_block": "шым",
  "block.minecraft.dirt": "топырақ",
  "block.minecraft.coarse_dirt": "тасты топырақ",
  "block.minecraft.podzol": "күлгін топырақ",
  "block.minecraft.crimson_nylium": "қырмызы нилий",
  "block.minecraft.warped_nylium": "бүлінген нилий",
  "block.minecraft.cobblestone": "жұмыртас",
  "block.minecraft.oak_planks": "емен тақтай",
  "block.minecraft.spruce_planks": "шырша тақтай",
  "block.minecraft.birch_planks": "қайың тақтай",
  "block.minecraft.jungle_planks": "джунгли тақтайы",
  "block.minecraft.acacia_planks": "қараған тақтай",
  "block.minecraft.dark_oak_planks": "алабарқын емен тақтай",
  "block.minecraft.crimson_planks": "қырмызы тақтай",
  "block.minecraft.warped_planks": "бүлінген тақтай",
  "block.minecraft.oak_sapling": "емен көшеті",
  "block.minecraft.spruce_sapling": "шырша көшеті",
  "block.minecraft.birch_sapling": "қайың көшеті",
  "block.minecraft.jungle_sapling": "джунгли көшеті",
  "block.minecraft.acacia_sapling": "қараған көшеті",
  "block.minecraft.dark_oak_sapling": "алабарқын емен көшеті",
  "block.minecraft.bedrock": "бедрок",
  "block.minecraft.sand": "құм",
  "block.minecraft.red_sand": "қызыл құм",
  "block.minecraft.gravel": "қиыршықтас",
  "block.minecraft.gold_ore": "алтын кені",
  "block.minecraft.iron_ore": "темір кені",
  "block.minecraft.coal_ore": "көмір кені",
  "block.minecraft.nether_gold_ore": "незер алтын кені",
  "block.minecraft.oak_log": "емен бөренесі",
  "block.minecraft.spruce_log": "шырша бөренесі",
  "block.minecraft.birch_log": "қайың бөренесі",
  "block.minecraft.jungle_log": "джунгли бөренесі",
  "block.minecraft.acacia_log": "қараған бөренесі",
  "block.minecraft.dark_oak_log": "алабарқын емен бөренесі",
  "block.minecraft.crimson_stem": "қырмызы сабақ",
  "block.minecraft.warped_stem": "бүлінген сабақ",
  "block.minecraft.stripped_oak_log": "жонылған емен бөренесі",
  "block.minecraft.stripped_spruce_log": "жонылған шырша бөренесі",
  "block.minecraft.stripped_birch_log": "жонылған қайың бөренесі",
  "block.minecraft.stripped_jungle_log": "жонылған джунгли бөренесі",
  "block.minecraft.stripped_acacia_log": "жонылған қараған бөренесі",
  "block.minecraft.stripped_dark_oak_log": "жонылған алабарқын емен бөренесі",
  "block.minecraft.stripped_crimson_stem": "жонылған қырмызы сабақ",
  "block.minecraft.stripped_warped_stem": "жонылған бүлінген сабақ",
  "block.minecraft.stripped_oak_wood": "жонылған емен",
  "block.minecraft.stripped_spruce_wood": "жонылған шырша",
  "block.minecraft.stripped_birch_wood": "жонылған қайың",
  "block.minecraft.stripped_jungle_wood": "жонылған джунгли ағашы",
  "block.minecraft.stripped_acacia_wood": "жонылған қараған",
  "block.minecraft.stripped_dark_oak_wood": "жонылған алабарқын емен",
  "block.minecraft.stripped_crimson_hyphae": "жонылған қырмызы гифа",
  "block.minecraft.stripped_warped_hyphae": "жонылған бүлінген гифа",
  "block.minecraft.oak_wood": "емен",
  "block.minecraft.spruce_wood": "шырша",
  "block.minecraft.birch_wood": "қайың",
  "block.minecraft.jungle_wood": "джунгли ағашы",
  "block.minecraft.acacia_wood": "қараған",
  "block.minecraft.dark_oak_wood": "алабарқын емен",
  "block.minecraft.crimson_hyphae": "қырмызы гифа",
  "block.minecraft.warped_hyphae": "бүлінген гифа",
  "block.minecraft.oak_leaves": "емен жапырағы",
  "block.minecraft.spruce_leaves": "шырша жапырағы",
  "block.minecraft.birch_leaves": "қайың жапырағы",
  "block.minecraft.jungle_leaves": "джунгли жапырағы",
  "block.minecraft.acacia_leaves": "қараған жапырағы",
  "block.minecraft.dark_oak_leaves": "алабарқын емен жапырағы",
  "block.minecraft.sponge": "ысқыш",
  "block.minecraft.wet_sponge": "су ысқыш",
  "block.minecraft.glass": "шыны",
  "block.minecraft.lapis_ore": "лазурит кені",
  "block.minecraft.lapis_block": "лазурит блок",
  "block.minecraft.dispenser": "таратқыш",
  "block.minecraft.sandstone": "құмтас",
  "block.minecraft.chiseled_sandstone": "оюлы құмтас",
  "block.minecraft.cut_sandstone": "кесілген құмтас",
  "block.minecraft.note_block": "нота блогі",
  "block.minecraft.powered_rail": "қуатты рельс",
  "block.minecraft.detector_rail": "сезбекті рельс",
  "block.minecraft.sticky_piston": "жабысқақ піспек",
  "block.minecraft.cobweb": "өрмекші торы",
  "block.minecraft.grass": "шөп",
  "block.minecraft.fern": "қырыққұлақ",
  "block.minecraft.dead_bush": "өлі бұта",
  "block.minecraft.seagrass": "теңізшөп",
  "block.minecraft.sea_pickle": "теңіз қияры",
  "block.minecraft.piston": "піспек",
  "block.minecraft.white_wool": "ақ жүн",
  "block.minecraft.orange_wool": "қызғылт сары жүн",
  "block.minecraft.magenta_wool": "ашық күлгін жүн",
  "block.minecraft.light_blue_wool": "көгілдір жүн",
  "block.minecraft.yellow_wool": "сары жүн",
  "block.minecraft.lime_wool": "лайм жүн",
  "block.minecraft.pink_wool": "қызғылт жүн",
  "block.minecraft.gray_wool": "сұр жүн",
  "block.minecraft.light_gray_wool": "боз жүн",
  "block.minecraft.cyan_wool": "көкзеңгір жүн",
  "block.minecraft.purple_wool": "күлгін жүн",
  "block.minecraft.blue_wool": "көк жүн",
  "block.minecraft.brown_wool": "қоңыр жүн",
  "block.minecraft.green_wool": "жасыл жүн",
  "block.minecraft.red_wool": "қызыл жүн",
  "block.minecraft.black_wool": "қара жүн",
  "block.minecraft.dandelion": "бақбақ",
  "block.minecraft.poppy": "көкнәр",
  "block.minecraft.blue_orchid": "көк сүйсін",
  "block.minecraft.allium": "жуа",
  "block.minecraft.azure_bluet": "хаустония",
  "block.minecraft.red_tulip": "қызыл қызғалдақ",
  "block.minecraft.orange_tulip": "қызғылт сары қызғалдақ",
  "block.minecraft.white_tulip": "ақ қызғалдақ",
  "block.minecraft.pink_tulip": "қызғылт қызғалдақ",
  "block.minecraft.oxeye_daisy": "түймедақ",
  "block.minecraft.cornflower": "көк кекіре",
  "block.minecraft.lily_of_the_valley": "меруертгүл",
  "block.minecraft.wither_rose": "уизер раушаны",
  "block.minecraft.brown_mushroom": "қоңыр саңырауқұлақ",
  "block.minecraft.red_mushroom": "қызыл саңырауқулақ",
  "block.minecraft.crimson_fungus": "қырмызы саңырауқұлақ",
  "block.minecraft.warped_fungus": "бүлінген саңырауқұлақ",
  "block.minecraft.crimson_roots": "қырмызы тамыр",
  "block.minecraft.warped_roots": "бүлінген тамыр",
  "block.minecraft.nether_sprouts": "незер өскіні",
  "block.minecraft.weeping_vines": "жылауық шыбық",
  "block.minecraft.twisting_vines": "ирек шыбық",
  "block.minecraft.sugar_cane": "қант қамысы",
  "block.minecraft.kelp": "ламинария",
  "block.minecraft.bamboo": "бамбук",
  "block.minecraft.gold_block": "алтын блок",
  "block.minecraft.iron_block": "темір блок",
  "block.minecraft.oak_slab": "емен тақта",
  "block.minecraft.spruce_slab": "шырша тақта",
  "block.minecraft.birch_slab": "қайың тақта",
  "block.minecraft.jungle_slab": "джунгли тақтасы",
  "block.minecraft.acacia_slab": "қараған тақта",
  "block.minecraft.dark_oak_slab": "алабарқын емен тақта",
  "block.minecraft.crimson_slab": "қырмызы тақта",
  "block.minecraft.warped_slab": "бүлінген тақта",
  "block.minecraft.stone_slab": "тас тақта",
  "block.minecraft.smooth_stone_slab": "тегіс тас тақта",
  "block.minecraft.sandstone_slab": "құмтас тақта",
  "block.minecraft.cut_sandstone_slab": "кесілген құмтас тақта",
  "block.minecraft.petrified_oak_slab": "тастанған емен тақта",
  "block.minecraft.cobblestone_slab": "жұмыртас тақта",
  "block.minecraft.brick_slab": "кірпіш тақта",
  "block.minecraft.stone_brick_slab": "тас кірпіш тақта",
  "block.minecraft.nether_brick_slab": "незер кірпіш тақтасы",
  "block.minecraft.quartz_slab": "кварц тақта",
  "block.minecraft.red_sandstone_slab": "қызыл құмтас тақта",
  "block.minecraft.cut_red_sandstone_slab": "кесілген қызыл құмтас тақта",
  "block.minecraft.purpur_slab": "пурпур тақта",
  "block.minecraft.prismarine_slab": "призмарин тақта",
  "block.minecraft.prismarine_brick_slab": "призмарин кірпіш тақта",
  "block.minecraft.dark_prismarine_slab": "қара призмарин тақта",
  "block.minecraft.smooth_quartz": "тегіс кварц блок",
  "block.minecraft.smooth_red_sandstone": "тегіс қызыл құмтас",
  "block.minecraft.smooth_sandstone": "тегіс құмтас",
  "block.minecraft.smooth_stone": "тегіс тас",
  "block.minecraft.bricks": "кірпіш",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "кітап сөресі",
  "block.minecraft.mossy_cobblestone": "мүкті жұмыртас",
  "block.minecraft.obsidian": "обсидиан",
  "block.minecraft.torch": "шырақ",
  "block.minecraft.end_rod": "енд шыбығы",
  "block.minecraft.chorus_plant": "хорус",
  "block.minecraft.chorus_flower": "хорус гүлі",
  "block.minecraft.purpur_block": "пурпур",
  "block.minecraft.purpur_pillar": "пурпур бағана",
  "block.minecraft.purpur_stairs": "пурпур баспалдақ",
  "block.minecraft.spawner": "жаратқыш",
  "block.minecraft.oak_stairs": "емен баспалдақ",
  "block.minecraft.chest": "сандық",
  "block.minecraft.diamond_ore": "алмас кені",
  "block.minecraft.diamond_block": "алмас блок",
  "block.minecraft.crafting_table": "жасау үстелі",
  "block.minecraft.farmland": "егістік топырақ",
  "block.minecraft.furnace": "пеш",
  "block.minecraft.ladder": "саты",
  "block.minecraft.rail": "рельс",
  "block.minecraft.cobblestone_stairs": "жұмыртас баспалдақ",
  "block.minecraft.lever": "иінтірек",
  "block.minecraft.stone_pressure_plate": "тас қысым тілімі",
  "block.minecraft.oak_pressure_plate": "емен қысым тілімі",
  "block.minecraft.spruce_pressure_plate": "шырша қысым тілімі",
  "block.minecraft.birch_pressure_plate": "қайың қысым тілімі",
  "block.minecraft.jungle_pressure_plate": "джунгли қысым тілімі",
  "block.minecraft.acacia_pressure_plate": "қараған қысым тілімі",
  "block.minecraft.dark_oak_pressure_plate": "алабарқын емен қысым тілімі",
  "block.minecraft.crimson_pressure_plate": "қырмызы қысым тілімі",
  "block.minecraft.warped_pressure_plate": "бүлінген қысым тілімі",
  "block.minecraft.polished_blackstone_pressure_plate": "жылтыр қаратас қысым тілімі",
  "block.minecraft.redstone_ore": "редстоун кені",
  "block.minecraft.redstone_torch": "редстоун шырағы",
  "block.minecraft.snow": "қар",
  "block.minecraft.ice": "мұз",
  "block.minecraft.snow_block": "қар блок",
  "block.minecraft.cactus": "кактус",
  "block.minecraft.clay": "саз",
  "block.minecraft.jukebox": "ойнатқыш",
  "block.minecraft.oak_fence": "емен шарбақ",
  "block.minecraft.spruce_fence": "шырша шарбақ",
  "block.minecraft.birch_fence": "қайың шарбақ",
  "block.minecraft.jungle_fence": "джунгли шарбағы",
  "block.minecraft.acacia_fence": "қараған шарбақ",
  "block.minecraft.dark_oak_fence": "алабарқын емен шарбақ",
  "block.minecraft.crimson_fence": "қырмызы шарбақ",
  "block.minecraft.warped_fence": "бүлінген шарбақ",
  "block.minecraft.pumpkin": "асқабақ",
  "block.minecraft.carved_pumpkin": "оюлы асқабақ",
  "block.minecraft.netherrack": "незерек",
  "block.minecraft.soul_sand": "жан құмы",
  "block.minecraft.soul_soil": "жан топырағы",
  "block.minecraft.basalt": "базальт",
  "block.minecraft.polished_basalt": "жылтыр базальт",
  "block.minecraft.soul_torch": "жан шырағы",
  "block.minecraft.glowstone": "жарықтас",
  "block.minecraft.jack_o_lantern": "жәк шамы",
  "block.minecraft.oak_trapdoor": "емен люк",
  "block.minecraft.spruce_trapdoor": "шырша люк",
  "block.minecraft.birch_trapdoor": "қайың люк",
  "block.minecraft.jungle_trapdoor": "джунгли люгі",
  "block.minecraft.acacia_trapdoor": "қараған люк",
  "block.minecraft.dark_oak_trapdoor": "алабарқын емен люк",
  "block.minecraft.crimson_trapdoor": "қырмызы люк",
  "block.minecraft.warped_trapdoor": "бүлінген люк",
  "block.minecraft.infested_stone": "жұқпаланған тас",
  "block.minecraft.infested_cobblestone": "жұқпаланған жұмыртас",
  "block.minecraft.infested_stone_bricks": "жұқпаланған тас кірпіш",
  "block.minecraft.infested_mossy_stone_bricks": "жұқпаланған мүкті тас кірпіш",
  "block.minecraft.infested_cracked_stone_bricks": "жұқпаланған шытынаған тас кірпіш",
  "block.minecraft.infested_chiseled_stone_bricks": "жұқпаланған оюлы тас кірпіш",
  "block.minecraft.stone_bricks": "тас кірпіш",
  "block.minecraft.mossy_stone_bricks": "мүкті тас кірпіш",
  "block.minecraft.cracked_stone_bricks": "шытынаған тас кірпіш",
  "block.minecraft.chiseled_stone_bricks": "оюлы тас кірпіш",
  "block.minecraft.brown_mushroom_block": "қоңыр саңырауқұлақ блок",
  "block.minecraft.red_mushroom_block": "қызыл саңырауқұлақ блок",
  "block.minecraft.mushroom_stem": "саңырауқұлақ сабағы",
  "block.minecraft.iron_bars": "темір шыбық",
  "block.minecraft.chain": "шынжыр",
  "block.minecraft.glass_pane": "әйнек",
  "block.minecraft.melon": "қарбыз",
  "block.minecraft.vine": "лиана",
  "block.minecraft.oak_fence_gate": "емен шарбақ қақпасы",
  "block.minecraft.spruce_fence_gate": "шырша шарбақ қақпасы",
  "block.minecraft.birch_fence_gate": "қайың шарбақ қақпасы",
  "block.minecraft.jungle_fence_gate": "джунгли шарбақ қақпасы",
  "block.minecraft.acacia_fence_gate": "қараған шарбақ қақпасы",
  "block.minecraft.dark_oak_fence_gate": "алабарқын емен шарбақ қақпасы",
  "block.minecraft.crimson_fence_gate": "қырмызы шарбақ қақпасы",
  "block.minecraft.warped_fence_gate": "бүлінген шарбақ қақпасы",
  "block.minecraft.brick_stairs": "кірпіш баспалдақ",
  "block.minecraft.stone_brick_stairs": "тас кірпіш баспалдақ",
  "block.minecraft.mycelium": "мицелий",
  "block.minecraft.lily_pad": "тұңғиық",
  "block.minecraft.nether_bricks": "незер кірпіші",
  "block.minecraft.cracked_nether_bricks": "шытынаған незер кірпіші",
  "block.minecraft.chiseled_nether_bricks": "оюлы незер кірпіші",
  "block.minecraft.nether_brick_fence": "незер кірпіш шарбағы",
  "block.minecraft.nether_brick_stairs": "незер кірпіш баспалдағы",
  "block.minecraft.enchanting_table": "сиқырлау үстелі",
  "block.minecraft.end_portal_frame": "енд портал жақтауы",
  "block.minecraft.end_stone": "енд тасы",
  "block.minecraft.end_stone_bricks": "енд тас кірпіші",
  "block.minecraft.dragon_egg": "айдаһар жұмыртқасы",
  "block.minecraft.redstone_lamp": "редстоун шамы",
  "block.minecraft.sandstone_stairs": "құмтас баспалдақ",
  "block.minecraft.emerald_ore": "замартас кені",
  "block.minecraft.ender_chest": "ендер сандық",
  "block.minecraft.tripwire_hook": "кергі ілмегі",
  "block.minecraft.emerald_block": "замартас блок",
  "block.minecraft.spruce_stairs": "шырша баспалдақ",
  "block.minecraft.birch_stairs": "қайың баспалдақ",
  "block.minecraft.jungle_stairs": "джунгли баспалдағы",
  "block.minecraft.crimson_stairs": "қырмызы баспалдақ",
  "block.minecraft.warped_stairs": "бүлінген баспалдақ",
  "block.minecraft.command_block": "пәрмен блогі",
  "block.minecraft.beacon": "шамшырақ",
  "block.minecraft.cobblestone_wall": "жұмыртас дуал",
  "block.minecraft.mossy_cobblestone_wall": "мүкті жұмыртас дуал",
  "block.minecraft.brick_wall": "кірпіш дуал",
  "block.minecraft.prismarine_wall": "призмарин дуал",
  "block.minecraft.red_sandstone_wall": "қызыл құмтас дуал",
  "block.minecraft.mossy_stone_brick_wall": "мүкті тас кірпіш дуал",
  "block.minecraft.granite_wall": "гранит дуал",
  "block.minecraft.stone_brick_wall": "тас кірпіш дуал",
  "block.minecraft.nether_brick_wall": "незер кірпіш дуалы",
  "block.minecraft.andesite_wall": "андезит дуал",
  "block.minecraft.red_nether_brick_wall": "қызыл незер кірпіш дуалы",
  "block.minecraft.sandstone_wall": "құмтас дуал",
  "block.minecraft.end_stone_brick_wall": "енд тас кірпіш дуалы",
  "block.minecraft.diorite_wall": "диорит дуал",
  "block.minecraft.blackstone_wall": "қаратас дуал",
  "block.minecraft.polished_blackstone_wall": "жылтыр қаратас дуал",
  "block.minecraft.polished_blackstone_brick_wall": "жылтыр қаратас кірпіш дуал",
  "block.minecraft.stone_button": "тас түйме",
  "block.minecraft.oak_button": "емен түйме",
  "block.minecraft.spruce_button": "шырша түйме",
  "block.minecraft.birch_button": "қайың түйме",
  "block.minecraft.jungle_button": "джунгли түймесі",
  "block.minecraft.acacia_button": "қараған түйме",
  "block.minecraft.dark_oak_button": "алабарқын емен түйме",
  "block.minecraft.crimson_button": "қырмызы түйме",
  "block.minecraft.warped_button": "бүлінген түйме",
  "block.minecraft.polished_blackstone_button": "жылтыр қаратас түйме",
  "block.minecraft.anvil": "төс",
  "block.minecraft.chipped_anvil": "шытынаған төс",
  "block.minecraft.damaged_anvil": "сынған төс",
  "block.minecraft.trapped_chest": "тұзақ сандық",
  "block.minecraft.light_weighted_pressure_plate": "кіші салмақтық қысым тілімі",
  "block.minecraft.heavy_weighted_pressure_plate": "үлкен салмақтық қысым тілімі",
  "block.minecraft.daylight_detector": "күн жарығы детекторы",
  "block.minecraft.redstone_block": "редстоун блок",
  "block.minecraft.nether_quartz_ore": "незер кварц кені",
  "block.minecraft.hopper": "құйғыш",
  "block.minecraft.chiseled_quartz_block": "оюлы кварц блок",
  "block.minecraft.quartz_block": "кварц блок",
  "block.minecraft.quartz_bricks": "кварц кірпіш",
  "block.minecraft.quartz_pillar": "кварц бағана",
  "block.minecraft.quartz_stairs": "кварц баспалдақ",
  "block.minecraft.activator_rail": "белсендіргіш рельс",
  "block.minecraft.dropper": "тастағыш",
  "block.minecraft.white_terracotta": "ақ қыш",
  "block.minecraft.orange_terracotta": "қызғылт сары қыш",
  "block.minecraft.magenta_terracotta": "ашық күлгін қыш",
  "block.minecraft.light_blue_terracotta": "көгілдір қыш",
  "block.minecraft.yellow_terracotta": "сары қыш",
  "block.minecraft.lime_terracotta": "лайм қыш",
  "block.minecraft.pink_terracotta": "қызғылт қыш",
  "block.minecraft.gray_terracotta": "сұр қыш",
  "block.minecraft.light_gray_terracotta": "боз қыш",
  "block.minecraft.cyan_terracotta": "көкзеңгір қыш",
  "block.minecraft.purple_terracotta": "күлгін қыш",
  "block.minecraft.blue_terracotta": "көк қыш",
  "block.minecraft.brown_terracotta": "қоңыр қыш",
  "block.minecraft.green_terracotta": "жасыл қыш",
  "block.minecraft.red_terracotta": "қызыл қыш",
  "block.minecraft.black_terracotta": "қара қыш",
  "block.minecraft.barrier": "тосқауыл",
  "block.minecraft.iron_trapdoor": "темір люк",
  "block.minecraft.hay_block": "бау пішен",
  "block.minecraft.white_carpet": "ақ кілем",
  "block.minecraft.orange_carpet": "қызғылт сары кілем",
  "block.minecraft.magenta_carpet": "ашық күлгін кілем",
  "block.minecraft.light_blue_carpet": "көгілдір кілем",
  "block.minecraft.yellow_carpet": "сары кілем",
  "block.minecraft.lime_carpet": "лайм кілем",
  "block.minecraft.pink_carpet": "қызғылт кілем",
  "block.minecraft.gray_carpet": "сұр кілем",
  "block.minecraft.light_gray_carpet": "боз кілем",
  "block.minecraft.cyan_carpet": "көкзеңгір кілем",
  "block.minecraft.purple_carpet": "күлгін кілем",
  "block.minecraft.blue_carpet": "көк кілем",
  "block.minecraft.brown_carpet": "қоңыр кілем",
  "block.minecraft.green_carpet": "жасыл кілем",
  "block.minecraft.red_carpet": "қызыл кілем",
  "block.minecraft.black_carpet": "қара кілем",
  "block.minecraft.terracotta": "қыш",
  "block.minecraft.coal_block": "көмір блок",
  "block.minecraft.packed_ice": "тығыз мұз",
  "block.minecraft.acacia_stairs": "қараған баспалдақ",
  "block.minecraft.dark_oak_stairs": "алабарқын емен баспалдақ",
  "block.minecraft.slime_block": "шырыш блок",
  "block.minecraft.grass_path": "соқпақ",
  "block.minecraft.sunflower": "күнбағыс",
  "block.minecraft.lilac": "мамыргүл",
  "block.minecraft.rose_bush": "раушан бұтасы",
  "block.minecraft.peony": "таушымылдық",
  "block.minecraft.tall_grass": "ұзын шөп",
  "block.minecraft.large_fern": "үлкен қырыққұлақ",
  "block.minecraft.white_stained_glass": "ақ шыны",
  "block.minecraft.orange_stained_glass": "қызғылт сары шыны",
  "block.minecraft.magenta_stained_glass": "ашық күлгін шыны",
  "block.minecraft.light_blue_stained_glass": "көгілдір шыны",
  "block.minecraft.yellow_stained_glass": "сары шыны",
  "block.minecraft.lime_stained_glass": "лайм шыны",
  "block.minecraft.pink_stained_glass": "қызғылт шыны",
  "block.minecraft.gray_stained_glass": "сұр шыны",
  "block.minecraft.light_gray_stained_glass": "боз шыны",
  "block.minecraft.cyan_stained_glass": "көкзеңгір шыны",
  "block.minecraft.purple_stained_glass": "күлгін шыны",
  "block.minecraft.blue_stained_glass": "көк шыны",
  "block.minecraft.brown_stained_glass": "қоңыр шыны",
  "block.minecraft.green_stained_glass": "жасыл шыны",
  "block.minecraft.red_stained_glass": "қызыл шыны",
  "block.minecraft.black_stained_glass": "қара шыны",
  "block.minecraft.white_stained_glass_pane": "ақ әйнек",
  "block.minecraft.orange_stained_glass_pane": "қызғылт сары әйнек",
  "block.minecraft.magenta_stained_glass_pane": "ашық күлгін әйнек",
  "block.minecraft.light_blue_stained_glass_pane": "көгілдір әйнек",
  "block.minecraft.yellow_stained_glass_pane": "сары әйнек",
  "block.minecraft.lime_stained_glass_pane": "лайм әйнек",
  "block.minecraft.pink_stained_glass_pane": "қызғылт әйнек",
  "block.minecraft.gray_stained_glass_pane": "сұр әйнек",
  "block.minecraft.light_gray_stained_glass_pane": "боз әйнек",
  "block.minecraft.cyan_stained_glass_pane": "көкзеңгір әйнек",
  "block.minecraft.purple_stained_glass_pane": "күлгін әйнек",
  "block.minecraft.blue_stained_glass_pane": "көк әйнек",
  "block.minecraft.brown_stained_glass_pane": "қоңыр әйнек",
  "block.minecraft.green_stained_glass_pane": "жасыл әйнек",
  "block.minecraft.red_stained_glass_pane": "қызыл әйнек",
  "block.minecraft.black_stained_glass_pane": "қара әйнек",
  "block.minecraft.prismarine": "призмарин",
  "block.minecraft.prismarine_bricks": "призмарин кірпіш",
  "block.minecraft.dark_prismarine": "қара призмарин",
  "block.minecraft.prismarine_stairs": "призмарин баспалдақ",
  "block.minecraft.prismarine_brick_stairs": "призмарин кірпіш баспалдақ",
  "block.minecraft.dark_prismarine_stairs": "қара призмарин баспалдақ",
  "block.minecraft.sea_lantern": "теңіз шамы",
  "block.minecraft.red_sandstone": "қызыл құмтас",
  "block.minecraft.chiseled_red_sandstone": "оюлы қызыл құмтас",
  "block.minecraft.cut_red_sandstone": "кесілген қызыл құмтас",
  "block.minecraft.red_sandstone_stairs": "қызыл құмтас баспалдақ",
  "block.minecraft.repeating_command_block": "қайталауыш пәрмен блогі",
  "block.minecraft.chain_command_block": "тізбектік пәрмен блогі",
  "block.minecraft.magma_block": "магма",
  "block.minecraft.nether_wart_block": "незер без блогі",
  "block.minecraft.warped_wart_block": "бүлінген без блок",
  "block.minecraft.red_nether_bricks": "қызыл незер кірпіші",
  "block.minecraft.bone_block": "сүйек блок",
  "block.minecraft.structure_void": "құрылыс бостығы",
  "block.minecraft.observer": "бақылауыш",
  "block.minecraft.shulker_box": "шалкер жәшігі",
  "block.minecraft.white_shulker_box": "ақ шалкер жәшігі",
  "block.minecraft.orange_shulker_box": "қызғылт сары шалкер жәшігі",
  "block.minecraft.magenta_shulker_box": "ашық күлгін шалкер жәшігі",
  "block.minecraft.light_blue_shulker_box": "көгілдір шалкер жәшігі",
  "block.minecraft.yellow_shulker_box": "сары шалкер жәшігі",
  "block.minecraft.lime_shulker_box": "лайм шалкер жәшігі",
  "block.minecraft.pink_shulker_box": "қызғылт шалкер жәшігі",
  "block.minecraft.gray_shulker_box": "сұр шалкер жәшігі",
  "block.minecraft.light_gray_shulker_box": "боз шалкер жәшігі",
  "block.minecraft.cyan_shulker_box": "көкзеңгір шалкер жәшігі",
  "block.minecraft.purple_shulker_box": "күлгін шалкер жәшігі",
  "block.minecraft.blue_shulker_box": "көк шалкер жәшігі",
  "block.minecraft.brown_shulker_box": "қоңыр шалкер жәшігі",
  "block.minecraft.green_shulker_box": "жасыл шалкер жәшігі",
  "block.minecraft.red_shulker_box": "қызыл шалкер жәшігі",
  "block.minecraft.black_shulker_box": "қара шалкер жәшігі",
  "block.minecraft.white_glazed_terracotta": "ақ көркемқыш",
  "block.minecraft.orange_glazed_terracotta": "қызғылт сары көркемқыш",
  "block.minecraft.magenta_glazed_terracotta": "ашық күлгін көркемқыш",
  "block.minecraft.light_blue_glazed_terracotta": "көгілдір көркемқыш",
  "block.minecraft.yellow_glazed_terracotta": "сары көркемқыш",
  "block.minecraft.lime_glazed_terracotta": "лайм көркемқыш",
  "block.minecraft.pink_glazed_terracotta": "қызғылт көркемқыш",
  "block.minecraft.gray_glazed_terracotta": "сұр көркемқыш",
  "block.minecraft.light_gray_glazed_terracotta": "боз көркемқыш",
  "block.minecraft.cyan_glazed_terracotta": "көкзеңгір көркемқыш",
  "block.minecraft.purple_glazed_terracotta": "күлгін көркемқыш",
  "block.minecraft.blue_glazed_terracotta": "көк көркемқыш",
  "block.minecraft.brown_glazed_terracotta": "қоңыр көркемқыш",
  "block.minecraft.green_glazed_terracotta": "жасыл көркемқыш",
  "block.minecraft.red_glazed_terracotta": "қызыл көркемқыш",
  "block.minecraft.black_glazed_terracotta": "қара көркемқыш",
  "block.minecraft.white_concrete": "ақ бетон",
  "block.minecraft.orange_concrete": "қызғылт сары бетон",
  "block.minecraft.magenta_concrete": "ашық күлгін бетон",
  "block.minecraft.light_blue_concrete": "көгілдір бетон",
  "block.minecraft.yellow_concrete": "сары бетон",
  "block.minecraft.lime_concrete": "лайм бетон",
  "block.minecraft.pink_concrete": "қызғылт бетон",
  "block.minecraft.gray_concrete": "сұр бетон",
  "block.minecraft.light_gray_concrete": "боз бетон",
  "block.minecraft.cyan_concrete": "көкзеңгір бетон",
  "block.minecraft.purple_concrete": "күлгін бетон",
  "block.minecraft.blue_concrete": "көк бетон",
  "block.minecraft.brown_concrete": "қоңыр бетон",
  "block.minecraft.green_concrete": "жасыл бетон",
  "block.minecraft.red_concrete": "қызыл бетон",
  "block.minecraft.black_concrete": "қара бетон",
  "block.minecraft.white_concrete_powder": "ақ құрғақ бетон",
  "block.minecraft.orange_concrete_powder": "қызғылт сары құрғақ бетон",
  "block.minecraft.magenta_concrete_powder": "ашық күлгін құрғақ бетон",
  "block.minecraft.light_blue_concrete_powder": "көгілдір құрғақ бетон",
  "block.minecraft.yellow_concrete_powder": "сары құрғақ бетон",
  "block.minecraft.lime_concrete_powder": "лайм құрғақ бетон",
  "block.minecraft.pink_concrete_powder": "қызғылт құрғақ бетон",
  "block.minecraft.gray_concrete_powder": "сұр құрғақ бетон",
  "block.minecraft.light_gray_concrete_powder": "боз құрғақ бетон",
  "block.minecraft.cyan_concrete_powder": "көкзеңгір құрғақ бетон",
  "block.minecraft.purple_concrete_powder": "күлгін құрғақ бетон",
  "block.minecraft.blue_concrete_powder": "көк құрғақ бетон",
  "block.minecraft.brown_concrete_powder": "қоңыр құрғақ бетон",
  "block.minecraft.green_concrete_powder": "жасыл құрғақ бетон",
  "block.minecraft.red_concrete_powder": "қызыл құрғақ бетон",
  "block.minecraft.black_concrete_powder": "қара құрғақ бетон",
  "block.minecraft.turtle_egg": "тасбақа жұмыртқасы",
  "block.minecraft.dead_tube_coral_block": "өлі түтік маржан блок",
  "block.minecraft.dead_brain_coral_block": "өлі ми маржан блок",
  "block.minecraft.dead_bubble_coral_block": "өлі көпіршік маржан блок",
  "block.minecraft.dead_fire_coral_block": "өлі от маржан блок",
  "block.minecraft.dead_horn_coral_block": "өлі мүйіз маржан блок",
  "block.minecraft.tube_coral_block": "түтік маржан блок",
  "block.minecraft.brain_coral_block": "ми маржан блок",
  "block.minecraft.bubble_coral_block": "көпіршік маржан блок",
  "block.minecraft.fire_coral_block": "от маржан блок",
  "block.minecraft.horn_coral_block": "мүйіз маржан блок",
  "block.minecraft.tube_coral": "түтік маржан",
  "block.minecraft.brain_coral": "ми маржан",
  "block.minecraft.bubble_coral": "көпіршік маржан",
  "block.minecraft.fire_coral": "от маржан",
  "block.minecraft.horn_coral": "мүйіз маржан",
  "block.minecraft.dead_brain_coral": "өлі ми маржан",
  "block.minecraft.dead_bubble_coral": "өлі көпіршік маржан",
  "block.minecraft.dead_fire_coral": "өлі от маржан",
  "block.minecraft.dead_horn_coral": "өлі мүйіз маржан",
  "block.minecraft.dead_tube_coral": "өлі түтік маржан",
  "block.minecraft.tube_coral_fan": "желпуіш түтік маржан",
  "block.minecraft.brain_coral_fan": "желпуіш ми маржан",
  "block.minecraft.bubble_coral_fan": "желпуіш көпіршік маржан",
  "block.minecraft.fire_coral_fan": "желпуіш от маржан",
  "block.minecraft.horn_coral_fan": "желпуіш мүйіз маржан",
  "block.minecraft.dead_tube_coral_fan": "өлі желпуіш түтік маржан",
  "block.minecraft.dead_brain_coral_fan": "өлі желпуіш ми маржан",
  "block.minecraft.dead_bubble_coral_fan": "өлі желпуіш көпіршік маржан",
  "block.minecraft.dead_fire_coral_fan": "өлі желпуіш от маржан",
  "block.minecraft.dead_horn_coral_fan": "өлі желпуіш мүйіз маржан",
  "block.minecraft.blue_ice": "көк мұз",
  "block.minecraft.conduit": "арна",
  "block.minecraft.polished_granite_stairs": "жылтыр гранит баспалдақ",
  "block.minecraft.smooth_red_sandstone_stairs": "тегіс қызыл құмтас баспалдақ",
  "block.minecraft.mossy_stone_brick_stairs": "мүкті тас кірпіш баспалдақ",
  "block.minecraft.polished_diorite_stairs": "жылтыр диорит баспалдақ",
  "block.minecraft.mossy_cobblestone_stairs": "мүкті жұмыртас баспалдақ",
  "block.minecraft.end_stone_brick_stairs": "енд тас кірпіш баспалдағы",
  "block.minecraft.stone_stairs": "тас баспалдақ",
  "block.minecraft.smooth_sandstone_stairs": "тегіс құмтас баспалдақ",
  "block.minecraft.smooth_quartz_stairs": "тегіс кварц баспалдақ",
  "block.minecraft.granite_stairs": "гранит баспалдақ",
  "block.minecraft.andesite_stairs": "андезит баспалдақ",
  "block.minecraft.red_nether_brick_stairs": "қызыл незер кірпіш баспалдағы",
  "block.minecraft.polished_andesite_stairs": "жылтыр андезит баспалдақ",
  "block.minecraft.diorite_stairs": "диорит баспалдақ",
  "block.minecraft.polished_granite_slab": "жылтыр гранит тақта",
  "block.minecraft.smooth_red_sandstone_slab": "тегіс қызыл құмтас тақта",
  "block.minecraft.mossy_stone_brick_slab": "мүкті тас кірпіш тақта",
  "block.minecraft.polished_diorite_slab": "жылтыр диорит тақта",
  "block.minecraft.mossy_cobblestone_slab": "мүкті жұмыртас тақта",
  "block.minecraft.end_stone_brick_slab": "енд тас кірпіш тақтасы",
  "block.minecraft.smooth_sandstone_slab": "тегіс құмтас тақта",
  "block.minecraft.smooth_quartz_slab": "тегіс кварц тақта",
  "block.minecraft.granite_slab": "гранит тақта",
  "block.minecraft.andesite_slab": "андезит тақта",
  "block.minecraft.red_nether_brick_slab": "қызыл незер кірпіш тақтасы",
  "block.minecraft.polished_andesite_slab": "жылтыр андезит тақта",
  "block.minecraft.diorite_slab": "диорит тақта",
  "block.minecraft.scaffolding": "мінбе",
  "block.minecraft.iron_door": "темір есік",
  "block.minecraft.oak_door": "емен есік",
  "block.minecraft.spruce_door": "шырша есік",
  "block.minecraft.birch_door": "қайың есік",
  "block.minecraft.jungle_door": "джунгли есігі",
  "block.minecraft.acacia_door": "қараған есік",
  "block.minecraft.dark_oak_door": "алабарқын емен есік",
  "block.minecraft.crimson_door": "қырмызы есік",
  "block.minecraft.warped_door": "бүлінген есік",
  "block.minecraft.repeater": "редстоун қайталауышы",
  "block.minecraft.comparator": "редстоун салыстырғышы",
  "block.minecraft.structure_block": "құрылыс блогі",
  "block.minecraft.jigsaw": "пазл блогі",
  "item.minecraft.turtle_helmet": "тасбақа сауыты□□басқа киілгенде:□+2 сауыт",
  "item.minecraft.scute": "қалқанша",
  "item.minecraft.iron_shovel": "темір күрек□□бас қолда болғанда:□+3.5 шабуыл зақымы□-3 шабуыл жылдамдығы",
  "item.minecraft.iron_pickaxe": "темір қайла□□бас қолда болғанда:□+3 шабуыл зақымы□-2.8 шабуыл жылдамдығы",
  "item.minecraft.iron_axe": "темір балта□□бас қолда болғанда:□+8 шабуыл зақымы□-3.1 шабуыл жылдамдығы",
  "item.minecraft.flint_and_steel": "шақпақ",
  "item.minecraft.apple": "алма",
  "item.minecraft.bow": "садақ",
  "item.minecraft.arrow": "оқ",
  "item.minecraft.coal": "көмір",
  "item.minecraft.charcoal": "ағаш көмірі",
  "item.minecraft.diamond": "алмас",
  "item.minecraft.iron_ingot": "темір құйма",
  "item.minecraft.gold_ingot": "алтын құйма",
  "item.minecraft.netherite_ingot": "незерит құйма",
  "item.minecraft.netherite_scrap": "незерит сынығы",
  "item.minecraft.iron_sword": "темір қылыш□□бас қолда болғанда:□+5 шабуыл зақымы□-2.4 шабуыл жылдамдығы",
  "item.minecraft.wooden_sword": "ағаш қылыш□□бас қолда болғанда:□+3 шабуыл зақымы□-2.4 шабуыл жылдамдығы",
  "item.minecraft.wooden_shovel": "ағаш күрек□□бас қолда болғанда:□+1.5 шабуыл зақымы□-3 шабуыл жылдамдығы",
  "item.minecraft.wooden_pickaxe": "ағаш қайла□□бас қолда болғанда:□+1 шабуыл зақымы□-2.8 шабуыл жылдамдығы",
  "item.minecraft.wooden_axe": "ағаш балта□□бас қолда болғанда:□+6 шабуыл зақымы□-3.2 шабуыл жылдамдығы",
  "item.minecraft.stone_sword": "тас қылыш□□бас қолда болғанда:□+4 шабуыл зақымы□-2.4 шабуыл жылдамдығы",
  "item.minecraft.stone_shovel": "тас күрек□□бас қолда болғанда:□+2.5 шабуыл зақымы□-3 шабуыл жылдамдығы",
  "item.minecraft.stone_pickaxe": "тас қайла□□бас қолда болғанда:□+2 шабуыл зақымы□-2.8 шабуыл жылдамдығы",
  "item.minecraft.stone_axe": "тас балта□□бас қолда болғанда:□+8 шабуыл зақымы□-3.2 шабуыл жылдамдығы",
  "item.minecraft.diamond_sword": "алмас қылыш□□бас қолда болғанда:□+6 шабуыл зақымы□-2.4 шабуыл жылдамдығы",
  "item.minecraft.diamond_shovel": "алмас күрек□□бас қолда болғанда:□+4.5 шабуыл зақымы□-3 шабуыл жылдамдығы",
  "item.minecraft.diamond_pickaxe": "алмас қайла□□бас қолда болғанда:□+4 шабуыл зақымы□-2.8 шабуыл жылдамдығы",
  "item.minecraft.diamond_axe": "алмас балта□□бас қолда болғанда:□+8 шабуыл зақымы□-3 шабуыл жылдамдығы",
  "item.minecraft.stick": "таяқ",
  "item.minecraft.bowl": "тостаған",
  "item.minecraft.mushroom_stew": "саңырауқұлақ көжесі",
  "item.minecraft.golden_sword": "алтын қылыш□□бас қолда болғанда:□+3 шабуыл зақымы□-2.4 шабуыл жылдамдығы",
  "item.minecraft.golden_shovel": "алтын күрек□□бас қолда болғанда:□+1.5 шабуыл зақымы□-3 шабуыл жылдамдығы",
  "item.minecraft.golden_pickaxe": "алтын қайла□□бас қолда болғанда:□+1 шабуыл зақымы□-2.8 шабуыл жылдамдығы",
  "item.minecraft.golden_axe": "алтын балта□□бас қолда болғанда:□+6 шабуыл зақымы□-3 шабуыл жылдамдығы",
  "item.minecraft.netherite_sword": "незерит қылыш□□бас қолда болғанда:□+7 шабуыл зақымы□-2.4 шабуыл жылдамдығы",
  "item.minecraft.netherite_shovel": "незерит күрек□□бас қолда болғанда:□+5.5 шабуыл зақымы□-3 шабуыл жылдамдығы",
  "item.minecraft.netherite_pickaxe": "незерит қайла□□бас қолда болғанда:□+5 шабуыл зақымы□-2.8 шабуыл жылдамдығы",
  "item.minecraft.netherite_axe": "незерит балта□□бас қолда болғанда:□+9 шабуыл зақымы□-3 шабуыл жылдамдығы",
  "item.minecraft.string": "жіп",
  "item.minecraft.feather": "қауырсын",
  "item.minecraft.gunpowder": "дәрі",
  "item.minecraft.wooden_hoe": "ағаш кетпен□□бас қолда болғанда:□-3 шабуыл жылдамдығы",
  "item.minecraft.stone_hoe": "тас кетпен□□бас қолда болғанда:□-2 шабуыл жылдамдығы",
  "item.minecraft.iron_hoe": "темір кетпен□□бас қолда болғанда:□-1 шабуыл жылдамдығы",
  "item.minecraft.diamond_hoe": "алмас кетпен□□бас қолда болғанда:",
  "item.minecraft.golden_hoe": "алтын кетпен□□бас қолда болғанда:□-3 шабуыл жылдамдығы",
  "item.minecraft.netherite_hoe": "незерит кетпен□□бас қолда болғанда:",
  "item.minecraft.wheat_seeds": "бидай тұқымы",
  "item.minecraft.wheat": "бидай",
  "item.minecraft.bread": "нан",
  "item.minecraft.leather_helmet": "тері қалпақ□□басқа киілгенде:□+1 сауыт",
  "item.minecraft.leather_chestplate": "тері күрте□□кеудеге киілгенде:□+3 сауыт",
  "item.minecraft.leather_leggings": "тері шалбар□□аяққа киілгенде:□+2 сауыт",
  "item.minecraft.leather_boots": "тері етік□□аяқ киім ретінде:□+1 сауыт",
  "item.minecraft.chainmail_helmet": "аймауыт дулыға□□басқа киілгенде:□+2 сауыт",
  "item.minecraft.chainmail_chestplate": "аймауыт кеудеше□□кеудеге киілгенде:□+5 сауыт",
  "item.minecraft.chainmail_leggings": "аймауыт шалбар□□аяққа киілгенде:□+4 сауыт",
  "item.minecraft.chainmail_boots": "аймауыт етік□□аяқ киім ретінде:□+1 сауыт",
  "item.minecraft.iron_helmet": "темір дулыға□□басқа киілгенде:□+2 сауыт",
  "item.minecraft.iron_chestplate": "темір кеудеше□□кеудеге киілгенде:□+6 сауыт",
  "item.minecraft.iron_leggings": "темір шалбар□□аяққа киілгенде:□+5 сауыт",
  "item.minecraft.iron_boots": "темір етік□□аяқ киім ретінде:□+2 сауыт",
  "item.minecraft.diamond_helmet": "алмас дулыға□□басқа киілгенде:□+3 сауыт□+2 сауыт беріктігі",
  "item.minecraft.diamond_chestplate": "алмас кеудеше□□кеудеге киілгенде:□+8 сауыт□+2 сауыт беріктігі",
  "item.minecraft.diamond_leggings": "алмас шалбар□□аяққа киілгенде:□+6 сауыт□+2 сауыт беріктігі",
  "item.minecraft.diamond_boots": "алмас етік□□аяқ киім ретінде:□+3 сауыт□+2 сауыт беріктігі",
  "item.minecraft.golden_helmet": "алтын дулыға□□басқа киілгенде:□+2 сауыт",
  "item.minecraft.golden_chestplate": "алтын кеудеше□□кеудеге киілгенде:□+5 сауыт",
  "item.minecraft.golden_leggings": "алтын шалбар□□аяққа киілгенде:□+3 сауыт",
  "item.minecraft.golden_boots": "алтын етік□□аяқ киім ретінде:□+1 сауыт",
  "item.minecraft.netherite_helmet": "незерит дулыға□□басқа киілгенде:□+3 сауыт□+3 сауыт беріктігі□+1 қайтарымға төзімділік",
  "item.minecraft.netherite_chestplate": "незерит кеудеше□□кеудеге киілгенде:□+8 сауыт□+3 сауыт беріктігі□+1 қайтарымға төзімділік",
  "item.minecraft.netherite_leggings": "незерит шалбар□□аяққа киілгенде:□+6 сауыт□+3 сауыт беріктігі□+1 қайтарымға төзімділік",
  "item.minecraft.netherite_boots": "незерит етік□□аяқ киім ретінде:□+3 сауыт□+3 сауыт беріктігі□+1 қайтарымға төзімділік",
  "item.minecraft.flint": "шақпақтас",
  "item.minecraft.porkchop": "шикі шошқа еті",
  "item.minecraft.cooked_porkchop": "піскен шошқа еті",
  "item.minecraft.painting": "сурет",
  "item.minecraft.golden_apple": "алтын алма",
  "item.minecraft.enchanted_golden_apple": "сиқырланған алтын алма",
  "block.minecraft.oak_sign": "емен маңдайша",
  "block.minecraft.spruce_sign": "шырша маңдайша",
  "block.minecraft.birch_sign": "қайың маңдайша",
  "block.minecraft.jungle_sign": "джунгли маңдайшасы",
  "block.minecraft.acacia_sign": "қараған маңдайша",
  "block.minecraft.dark_oak_sign": "алабарқын емен маңдайша",
  "block.minecraft.crimson_sign": "қырмызы маңдайша",
  "block.minecraft.warped_sign": "бүлінген маңдайша",
  "item.minecraft.bucket": "шелек",
  "item.minecraft.water_bucket": "шелек су",
  "item.minecraft.lava_bucket": "шелек лава",
  "item.minecraft.minecart": "вагонша",
  "item.minecraft.saddle": "ер",
  "item.minecraft.redstone": "редстоун ұнтағы",
  "item.minecraft.snowball": "кесек қар",
  "item.minecraft.oak_boat": "емен қайық",
  "item.minecraft.leather": "тері",
  "item.minecraft.milk_bucket": "шелек сүт",
  "item.minecraft.pufferfish_bucket": "шелектегі тікенқұрсақ",
  "item.minecraft.salmon_bucket": "шелектегі албырт",
  "item.minecraft.cod_bucket": "шелектегі сетінек",
  "item.minecraft.tropical_fish_bucket": "шелектегі тропиктік балық",
  "item.minecraft.brick": "кірпіш",
  "item.minecraft.clay_ball": "кесек саз",
  "block.minecraft.dried_kelp_block": "кептірілген ламинария блок",
  "item.minecraft.paper": "қағаз",
  "item.minecraft.book": "кітап",
  "item.minecraft.slime_ball": "кесек шырыш",
  "item.minecraft.chest_minecart": "сандық вагоншасы",
  "item.minecraft.furnace_minecart": "пеш вагоншасы",
  "item.minecraft.egg": "жұмыртқа",
  "item.minecraft.compass": "құбыланама",
  "item.minecraft.fishing_rod": "қармақ",
  "item.minecraft.clock": "сағат",
  "item.minecraft.glowstone_dust": "жарықтас ұнтағы",
  "item.minecraft.cod": "шикі сетінек",
  "item.minecraft.salmon": "шикі албырт",
  "item.minecraft.tropical_fish": "тропиктік балық",
  "item.minecraft.pufferfish": "тікенқұрсақ",
  "item.minecraft.cooked_cod": "піскен сетінек",
  "item.minecraft.cooked_salmon": "піскен албырт",
  "item.minecraft.ink_sac": "сия",
  "item.minecraft.red_dye": "қызыл бояғыш",
  "item.minecraft.green_dye": "жасыл бояғыш",
  "item.minecraft.cocoa_beans": "какао бұршағы",
  "item.minecraft.lapis_lazuli": "лазурит",
  "item.minecraft.purple_dye": "күлгін бояғыш",
  "item.minecraft.cyan_dye": "көкзеңгір бояғыш",
  "item.minecraft.light_gray_dye": "боз бояғыш",
  "item.minecraft.gray_dye": "сұр бояғыш",
  "item.minecraft.pink_dye": "қызғылт бояғыш",
  "item.minecraft.lime_dye": "лайм бояғыш",
  "item.minecraft.yellow_dye": "сары бояғыш",
  "item.minecraft.light_blue_dye": "көгілдір бояғыш",
  "item.minecraft.magenta_dye": "ашық күлгін бояғыш",
  "item.minecraft.orange_dye": "қызғылт сары бояғыш",
  "item.minecraft.bone_meal": "сүйек ұны",
  "item.minecraft.blue_dye": "көк бояғыш",
  "item.minecraft.brown_dye": "қоңыр бояғыш",
  "item.minecraft.black_dye": "қара бояғыш",
  "item.minecraft.white_dye": "ақ бояғыш",
  "item.minecraft.bone": "сүйек",
  "item.minecraft.sugar": "қант",
  "block.minecraft.cake": "торт",
  "block.minecraft.white_bed": "ақ төсек",
  "block.minecraft.orange_bed": "қызғылт сары төсек",
  "block.minecraft.magenta_bed": "ашық күлгін төсек",
  "block.minecraft.light_blue_bed": "көгілдір төсек",
  "block.minecraft.yellow_bed": "сары төсек",
  "block.minecraft.lime_bed": "лайм төсек",
  "block.minecraft.pink_bed": "қызғылт төсек",
  "block.minecraft.gray_bed": "сұр төсек",
  "block.minecraft.light_gray_bed": "боз төсек",
  "block.minecraft.cyan_bed": "көкзеңгір төсек",
  "block.minecraft.purple_bed": "күлгін төсек",
  "block.minecraft.blue_bed": "көк төсек",
  "block.minecraft.brown_bed": "қоңыр төсек",
  "block.minecraft.green_bed": "жасыл төсек",
  "block.minecraft.red_bed": "қызыл төсек",
  "block.minecraft.black_bed": "қара төсек",
  "item.minecraft.cookie": "піспенан",
  "item.minecraft.filled_map": "карта□#0",
  "item.minecraft.shears": "қайшы",
  "item.minecraft.melon_slice": "қарбыз тілімі",
  "item.minecraft.dried_kelp": "кептірілген ламинария",
  "item.minecraft.pumpkin_seeds": "асқабақ тұқымы",
  "item.minecraft.melon_seeds": "қарбыз тұқымы",
  "item.minecraft.beef": "шикі сиыр еті",
  "item.minecraft.cooked_beef": "cтейк",
  "item.minecraft.chicken": "шикі тауық еті",
  "item.minecraft.cooked_chicken": "піскен тауық еті",
  "item.minecraft.rotten_flesh": "шірік ет",
  "item.minecraft.ender_pearl": "ендер меруерті",
  "item.minecraft.blaze_rod": "лаулақ шыбығы",
  "item.minecraft.ghast_tear": "гаст көз жасы",
  "item.minecraft.gold_nugget": "алтын кесегі",
  "item.minecraft.nether_wart": "незер безі",
  "item.minecraft.potion": "жасалмайтын ішірткі□әсерсіз",
  "item.minecraft.glass_bottle": "бөтелке",
  "item.minecraft.spider_eye": "өрмекші көзі",
  "item.minecraft.fermented_spider_eye": "ашыған өрмекші көзі",
  "item.minecraft.blaze_powder": "лаулақ ұнтағы",
  "item.minecraft.magma_cream": "магма кремі",
  "block.minecraft.brewing_stand": "демдеуіш",
  "block.minecraft.cauldron": "қазан",
  "item.minecraft.ender_eye": "ендер көзі",
  "item.minecraft.glistering_melon_slice": "жарқырауық қарбыз тілімі",
  "item.minecraft.bat_spawn_egg": "жарқанат жарату жұмыртқасы",
  "item.minecraft.bee_spawn_egg": "ара жарату жұмыртқасы",
  "item.minecraft.blaze_spawn_egg": "лаулақ жарату жұмыртқасы",
  "item.minecraft.cat_spawn_egg": "мысық жарату жұмыртқасы",
  "item.minecraft.cave_spider_spawn_egg": "үңгір өрмекшісін жарату жұмыртқасы",
  "item.minecraft.chicken_spawn_egg": "тауық жарату жұмыртқасы",
  "item.minecraft.cod_spawn_egg": "сетінек жарату жұмыртқасы",
  "item.minecraft.cow_spawn_egg": "сиыр жарату жұмыртқасы",
  "item.minecraft.creeper_spawn_egg": "крипер жарату жұмыртқасы",
  "item.minecraft.dolphin_spawn_egg": "дельфин жарату жұмыртқасы",
  "item.minecraft.donkey_spawn_egg": "есек жарату жұмыртқасы",
  "item.minecraft.drowned_spawn_egg": "батқан жарату жұмыртқасы",
  "item.minecraft.elder_guardian_spawn_egg": "ежелгі қорғаушы жарату жұмыртқасы",
  "item.minecraft.enderman_spawn_egg": "ендермен жарату жұмыртқасы",
  "item.minecraft.endermite_spawn_egg": "ендермит жарату жұмыртқасы",
  "item.minecraft.evoker_spawn_egg": "оятушы жарату жұмыртқасы",
  "item.minecraft.fox_spawn_egg": "түлкі жарату жұмыртқасы",
  "item.minecraft.ghast_spawn_egg": "гаст жарату жұмыртқасы",
  "item.minecraft.guardian_spawn_egg": "қорғаушы жарату жұмыртқасы",
  "item.minecraft.hoglin_spawn_egg": "хоглин жарату жұмыртқасы",
  "item.minecraft.horse_spawn_egg": "ат жарату жұмыртқасы",
  "item.minecraft.husk_spawn_egg": "мәйіт жарату жұмыртқасы",
  "item.minecraft.llama_spawn_egg": "лама жарату жұмыртқасы",
  "item.minecraft.magma_cube_spawn_egg": "магма кубын жарату жұмыртқасы",
  "item.minecraft.mooshroom_spawn_egg": "мөңіреуқұлақ жарату жұмыртқасы",
  "item.minecraft.mule_spawn_egg": "қашыр жарату жұмыртқасы",
  "item.minecraft.ocelot_spawn_egg": "оцелот жарату жұмыртқасы",
  "item.minecraft.panda_spawn_egg": "панда жарату жұмыртқасы",
  "item.minecraft.parrot_spawn_egg": "тоты жарату жұмыртқасы",
  "item.minecraft.phantom_spawn_egg": "фантом жарату жұмыртқасы",
  "item.minecraft.pig_spawn_egg": "шошқа жарату жұмыртқасы",
  "item.minecraft.piglin_spawn_egg": "пиглин жарату жұмыртқасы",
  "item.minecraft.pillager_spawn_egg": "тонаушы жарату жұмыртқасы",
  "item.minecraft.polar_bear_spawn_egg": "ақ аю жарату жұмыртқасы",
  "item.minecraft.pufferfish_spawn_egg": "тікенқұрсақ жарату жұмыртқасы",
  "item.minecraft.rabbit_spawn_egg": "қоян жарату жұмыртқасы",
  "item.minecraft.ravager_spawn_egg": "ойраншы жарату жұмыртқасы",
  "item.minecraft.salmon_spawn_egg": "албырт жарату жұмыртқасы",
  "item.minecraft.sheep_spawn_egg": "қой жарату жұмыртқасы",
  "item.minecraft.shulker_spawn_egg": "шалкер жарату жұмыртқасы",
  "item.minecraft.silverfish_spawn_egg": "күмісбалық жарату жұмыртқасы",
  "item.minecraft.skeleton_spawn_egg": "қаңқа жарату жұмыртқасы",
  "item.minecraft.skeleton_horse_spawn_egg": "қаңқа ат жарату жұмыртқасы",
  "item.minecraft.slime_spawn_egg": "шырыш жарату жұмыртқасы",
  "item.minecraft.spider_spawn_egg": "өрмекші жарату жұмыртқасы",
  "item.minecraft.squid_spawn_egg": "сегізаяқ жарату жұмыртқасы",
  "item.minecraft.stray_spawn_egg": "адасқан жарату жұмыртқасы",
  "item.minecraft.strider_spawn_egg": "лавакезер жарату жұмыртқасы",
  "item.minecraft.trader_llama_spawn_egg": "саудагер ламасын жарату жұмыртқасы",
  "item.minecraft.tropical_fish_spawn_egg": "тропиктік балық жарату жұмыртқасы",
  "item.minecraft.turtle_spawn_egg": "тасбақа жарату жұмыртқасы",
  "item.minecraft.vex_spawn_egg": "мазалаушы жарату жұмыртқасы",
  "item.minecraft.villager_spawn_egg": "шаруа жарату жұмыртқасы",
  "item.minecraft.vindicator_spawn_egg": "кекші жарату жұмыртқасы",
  "item.minecraft.wandering_trader_spawn_egg": "кезбе саудагер жарату жұмыртқасы",
  "item.minecraft.witch_spawn_egg": "мыстан жарату жұмыртқасы",
  "item.minecraft.wither_skeleton_spawn_egg": "уизер қаңқа жарату жұмыртқасы",
  "item.minecraft.wolf_spawn_egg": "қасқыр жарату жұмыртқасы",
  "item.minecraft.zoglin_spawn_egg": "зоглин жарату жұмыртқасы",
  "item.minecraft.zombie_spawn_egg": "зомби жарату жұмыртқасы",
  "item.minecraft.zombie_horse_spawn_egg": "зомби ат жарату жұмыртқасы",
  "item.minecraft.zombie_villager_spawn_egg": "зомби шаруа жарату жұмыртқасы",
  "item.minecraft.zombified_piglin_spawn_egg": "зомбиленген пиглин жарату жұмыртқасы",
  "item.minecraft.experience_bottle": "сиқырлау бөтелкесі",
  "item.minecraft.fire_charge": "от шар",
  "item.minecraft.writable_book": "кітап пен қауырсын",
  "item.minecraft.written_book": "бітірілген кітап",
  "item.minecraft.emerald": "замартас",
  "item.minecraft.item_frame": "жақтау",
  "block.minecraft.flower_pot": "гүл құмырасы",
  "item.minecraft.carrot": "сәбіз",
  "item.minecraft.potato": "картоп",
  "item.minecraft.baked_potato": "піскен картоп",
  "item.minecraft.poisonous_potato": "улы картоп",
  "item.minecraft.map": "бос карта",
  "item.minecraft.golden_carrot": "алтын сәбіз",
  "block.minecraft.skeleton_skull": "бас сүйек",
  "block.minecraft.wither_skeleton_skull": "уизер қаңқа бас сүйегі",
  "block.minecraft.player_head": "ойыншы басы",
  "block.minecraft.zombie_head": "зомби басы",
  "block.minecraft.creeper_head": "крипер басы",
  "block.minecraft.dragon_head": "айдаһар басы",
  "item.minecraft.carrot_on_a_stick": "таяқтағы сәбіз",
  "item.minecraft.warped_fungus_on_a_stick": "таяқтағы бүлінген саңырауқұлақ",
  "item.minecraft.nether_star": "незер жұлдызы",
  "item.minecraft.pumpkin_pie": "асқабақ қаусырмасы",
  "item.minecraft.firework_rocket": "отшашу",
  "item.minecraft.firework_star": "отшашу жұлдызы",
  "item.minecraft.enchanted_book": "сиқырланған кітап",
  "item.minecraft.nether_brick": "незер кірпіші",
  "item.minecraft.quartz": "незер кварцы",
  "item.minecraft.tnt_minecart": "tnt вагоншасы",
  "item.minecraft.hopper_minecart": "құйғыш вагоншасы",
  "item.minecraft.prismarine_shard": "призмарин сынығы",
  "item.minecraft.prismarine_crystals": "призмарин кристалы",
  "item.minecraft.rabbit": "шикі қоян еті",
  "item.minecraft.cooked_rabbit": "піскен қоян еті",
  "item.minecraft.rabbit_stew": "қоян көжесі",
  "item.minecraft.rabbit_foot": "қоян аяғы",
  "item.minecraft.rabbit_hide": "қоян терісі",
  "item.minecraft.armor_stand": "сауыт тірегі",
  "item.minecraft.iron_horse_armor": "темір ат сауыты",
  "item.minecraft.golden_horse_armor": "алтын ат сауыты",
  "item.minecraft.diamond_horse_armor": "алмас ат сауыты",
  "item.minecraft.leather_horse_armor": "тері ат сауыты",
  "item.minecraft.lead": "бау",
  "item.minecraft.name_tag": "ат таңбасы",
  "item.minecraft.command_block_minecart": "пәрмен вагоншасы",
  "item.minecraft.mutton": "шикі қой еті",
  "item.minecraft.cooked_mutton": "піскен қой еті",
  "block.minecraft.white_banner": "ақ байрақ",
  "block.minecraft.orange_banner": "қызғылт сары байрақ",
  "block.minecraft.magenta_banner": "ашық күлгін байрақ",
  "block.minecraft.light_blue_banner": "көгілдір байрақ",
  "block.minecraft.yellow_banner": "сары байрақ",
  "block.minecraft.lime_banner": "лайм байрақ",
  "block.minecraft.pink_banner": "қызғылт байрақ",
  "block.minecraft.gray_banner": "сұр байрақ",
  "block.minecraft.light_gray_banner": "боз байрақ",
  "block.minecraft.cyan_banner": "көкзеңгір байрақ",
  "block.minecraft.purple_banner": "күлгін байрақ",
  "block.minecraft.blue_banner": "көк байрақ",
  "block.minecraft.brown_banner": "қоңыр байрақ",
  "block.minecraft.green_banner": "жасыл байрақ",
  "block.minecraft.red_banner": "қызыл байрақ",
  "block.minecraft.black_banner": "қара байрақ",
  "item.minecraft.end_crystal": "енд кристалы",
  "item.minecraft.chorus_fruit": "хорус жемісі",
  "item.minecraft.popped_chorus_fruit": "қуырылған хорус жемісі",
  "item.minecraft.beetroot": "қызылша",
  "item.minecraft.beetroot_seeds": "қызылша тұқымы",
  "item.minecraft.beetroot_soup": "қызылша көжесі",
  "item.minecraft.dragon_breath": "айдаһар демі",
  "item.minecraft.splash_potion": "жасалмайтын жарылғыш ішірткі□әсерсіз",
  "item.minecraft.spectral_arrow": "спектрлік оқ",
  "item.minecraft.tipped_arrow": "жасалмайтын ішірткімен өңделген оқ□әсерсіз",
  "item.minecraft.lingering_potion": "жасалмайтын созылмалы ішірткі□әсерсіз",
  "item.minecraft.shield": "қалқан",
  "item.minecraft.elytra": "элитра",
  "item.minecraft.spruce_boat": "шырша қайық",
  "item.minecraft.birch_boat": "қайың қайық",
  "item.minecraft.jungle_boat": "джунгли қайығы",
  "item.minecraft.acacia_boat": "қараған қайық",
  "item.minecraft.dark_oak_boat": "алабарқын емен қайық",
  "item.minecraft.totem_of_undying": "өлімсіздік тотемі",
  "item.minecraft.shulker_shell": "шалкер сауыты",
  "item.minecraft.iron_nugget": "темір кесегі",
  "item.minecraft.knowledge_book": "білім кітабы",
  "item.minecraft.debug_stick": "оңдау таяғы",
  "item.minecraft.music_disc_13": "күйтабақ□c418 - 13",
  "item.minecraft.music_disc_cat": "күйтабақ□c418 - cat",
  "item.minecraft.music_disc_blocks": "күйтабақ□c418 - blocks",
  "item.minecraft.music_disc_chirp": "күйтабақ□c418 - chirp",
  "item.minecraft.music_disc_far": "күйтабақ□c418 - far",
  "item.minecraft.music_disc_mall": "күйтабақ□c418 - mall",
  "item.minecraft.music_disc_mellohi": "күйтабақ□c418 - mellohi",
  "item.minecraft.music_disc_stal": "күйтабақ□c418 - stal",
  "item.minecraft.music_disc_strad": "күйтабақ□c418 - strad",
  "item.minecraft.music_disc_ward": "күйтабақ□c418 - ward",
  "item.minecraft.music_disc_11": "күйтабақ□c418 - 11",
  "item.minecraft.music_disc_wait": "күйтабақ□c418 - wait",
  "item.minecraft.music_disc_pigstep": "күйтабақ□lena raine - pigstep",
  "item.minecraft.trident": "үштіс□□бас қолда болғанда:□+8 шабуыл зақымы□-2.9 шабуыл жылдамдығы",
  "item.minecraft.phantom_membrane": "фантом мембранасы",
  "item.minecraft.nautilus_shell": "наутилус бақалшағы",
  "item.minecraft.heart_of_the_sea": "теңіз жүрегі",
  "item.minecraft.crossbow": "арбалет",
  "item.minecraft.suspicious_stew": "күмәнді көже",
  "block.minecraft.loom": "тоқыма білдегі",
  "item.minecraft.flower_banner_pattern": "байрақ үлгісі□гүл",
  "item.minecraft.creeper_banner_pattern": "байрақ үлгісі□крипер",
  "item.minecraft.skull_banner_pattern": "байрақ үлгісі□бас сүйек",
  "item.minecraft.mojang_banner_pattern": "байрақ үлгісі□нәрсе",
  "item.minecraft.globe_banner_pattern": "байрақ үлгісі□глобус",
  "item.minecraft.piglin_banner_pattern": "байрақ үлгісі□тұмсық",
  "block.minecraft.composter": "қордалауыш",
  "block.minecraft.barrel": "бөшке",
  "block.minecraft.smoker": "ыстауыш",
  "block.minecraft.blast_furnace": "балқыту пеші",
  "block.minecraft.cartography_table": "картограф үстелі",
  "block.minecraft.fletching_table": "оқшы үстелі",
  "block.minecraft.grindstone": "қайрақ",
  "block.minecraft.lectern": "кафедра",
  "block.minecraft.smithing_table": "темірші үстелі",
  "block.minecraft.stonecutter": "таскескіш",
  "block.minecraft.bell": "қоңырау",
  "block.minecraft.lantern": "шам",
  "block.minecraft.soul_lantern": "жан шамы",
  "item.minecraft.sweet_berries": "тәтті жидек",
  "block.minecraft.campfire": "алау",
  "block.minecraft.soul_campfire": "жан алауы",
  "block.minecraft.shroomlight": "жарыққұлақ",
  "item.minecraft.honeycomb": "кәрез",
  "block.minecraft.bee_nest": "ара ұясы",
  "block.minecraft.beehive": "омарта",
  "item.minecraft.honey_bottle": "бөтелке бал",
  "block.minecraft.honey_block": "бал блок",
  "block.minecraft.honeycomb_block": "кәрез блок",
  "block.minecraft.lodestone": "бағдартас",
  "block.minecraft.netherite_block": "незерит блок",
  "block.minecraft.ancient_debris": "ежелгі сынық",
  "block.minecraft.target": "нысана",
  "block.minecraft.crying_obsidian": "жылаған обсидиан",
  "block.minecraft.blackstone": "қаратас",
  "block.minecraft.blackstone_slab": "қаратас тақта",
  "block.minecraft.blackstone_stairs": "қаратас баспалдақ",
  "block.minecraft.gilded_blackstone": "алтындалған қаратас",
  "block.minecraft.polished_blackstone": "жылтыр қаратас",
  "block.minecraft.polished_blackstone_slab": "жылтыр қаратас тақта",
  "block.minecraft.polished_blackstone_stairs": "жылтыр қаратас баспалдақ",
  "block.minecraft.chiseled_polished_blackstone": "оюлы жылтыр қаратас",
  "block.minecraft.polished_blackstone_bricks": "жылтыр қаратас кірпіш",
  "block.minecraft.polished_blackstone_brick_slab": "жылтыр қаратас кірпіш тақта",
  "block.minecraft.polished_blackstone_brick_stairs": "жылтыр қаратас кірпіш баспалдақ",
  "block.minecraft.cracked_polished_blackstone_bricks": "шытынаған жылтыр қаратас кірпіш",
  "block.minecraft.respawn_anchor": "тірілу зәкірі",
}
export const kk_kz = items; 
